import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UiState {
  isInsightDetailsOpen: boolean;
  insightDetailsContent: any[];
}

const initialState: UiState = {
  isInsightDetailsOpen: false,
  insightDetailsContent: [],
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    onOpenInsightDetails: (state, action: PayloadAction<any>) => {
      state.isInsightDetailsOpen = true;
      state.insightDetailsContent = action.payload;
    },
    onCloseInsightDetails: (state) => {
      state.isInsightDetailsOpen = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const { onCloseInsightDetails, onOpenInsightDetails } = uiSlice.actions;

export default uiSlice.reducer;
